module.exports = __webpack_public_path__ + "img/夢莎逆時雙效賦活霜Ⅱ.1b3a42d2.png";